import React from 'react';
import '../../styles/Contact.css';
import { 
  Mail
} from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const Contact: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="contact-footer">
      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <div className="contact-container">
          <div className="contact-content">
            <div className="contact-header">
              <h2 className="contact-title">
                {t('contact.title')}
              </h2>
              <p className="contact-subtitle">
                {t('contact.subtitle')}
              </p>
            </div>

            <div className="contact-grid">
              {/* Contact Information */}
              <div className="contact-info-container">
                <div className="contact-info-section">
                  <h3 className="info-title">{t('contact.info.title')}</h3>
                  <div className="contact-info-grid">
                    
                    <div className="contact-info-item">
                      <div className="info-icon-wrapper">
                        <Mail className="info-icon" />
                      </div>
                      <div className="info-content">
                        <p className="info-label">{t('contact.info.email')}</p>
                        <p className="info-value">Suporte@mozmina.com</p>
                        <p className="info-value">www.mozmina.com</p>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-brand">
             
              <span className="brand-name">Mozmina</span>
            </div>
            
            
            <p className="footer-copyright">
              {t('contact.footer.copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Contact;